import storage from 'local-storage-fallback'
import config from '../config'

// @todo this should use the state instead of the localStorage directly
// just didn't know how :)
export function generateApiUrl(path) {
    return config.serviceUrl + '/' + path + '?token=' + storage.getItem('refresh_token')
}
